import React, { useEffect, useState } from 'react';
import { getQueryString } from '../../../utils/params';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { BannerApartment, BreadcumbApartment, MenuApartment } from '../common';
import { getAmenities, getDescriptionFacility, getSpecialsFacility } from '../detailApartment.api';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function FacilitiesComponent() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { language } = useParams();
  const [descriptionFacility, setDescriptionFacility] = useState();
  const [specialsFacility, setSpecialsFacility] = useState();
  const [amenitiesInfo, setAmenitiesInfo] = useState();
  const { id } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    showLoader();
    getDescriptionFacility(getQueryString({ language, projectId: id })).then(res => {
      if (res) {
        setDescriptionFacility(res[0]);
      }
    });

    getSpecialsFacility(getQueryString({ language, projectId: id })).then(res => {
      if (res) {
        setSpecialsFacility(res);
      }
    });

    getAmenities(getQueryString({ language, projectId: id })).then(res => {
      if (res) {
        setAmenitiesInfo(res.facilities);
      }
    });
    hideLoader();
    //eslint-disable-next-line
  }, []);

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  return (
    <>
      <BreadcumbApartment />
      <BannerApartment />
      <MenuApartment />
      <div id="detailProjectFacilities">
        <div className="container" style={{ marginBottom: '70px' }}>
          {descriptionFacility ? (
            <div className="row px-3">
              <div className="detail-apartment-title">{descriptionFacility.name}</div>
              <div
                className="col-12 description"
                dangerouslySetInnerHTML={createMarkup(descriptionFacility.content)}
              ></div>
            </div>
          ) : (
            ''
          )}
          {specialsFacility
            ? specialsFacility.map((item, index) =>
                index % 2 > 0 ? (
                  <div key={index} className="row utilities-box">
                    <div className="col-6">
                      <div className="text-center utilities-title">{item.title}</div>
                      <div className="utilities-text" dangerouslySetInnerHTML={createMarkup(item.content)}></div>
                    </div>
                    <div className="col-6">
                      <img
                        style={{ width: '100%' }}
                        src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                        alt={item.title}
                      />
                    </div>
                  </div>
                ) : (
                  <div key={index} className="row utilities-box">
                    <div className="col-6">
                      <img
                        style={{ width: '100%' }}
                        src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                        alt={item.title}
                      />
                    </div>
                    <div className="col-6">
                      <div className="text-center utilities-title">{item.title}</div>
                      <div className="utilities-text" dangerouslySetInnerHTML={createMarkup(item.content)}></div>
                    </div>
                  </div>
                ),
              )
            : ''}
          <div className="amenities-box">
            {amenitiesInfo ? <div className="col-12 title pt-0">{t('detailProject.amenities')}</div> : ''}
            {amenitiesInfo
              ? amenitiesInfo.map((item, index) => (
                  <div key={index}>
                    <div className="col-12 amenities-title">{item.name}</div>
                    <ul className="row mt-2">
                      {item.items.map((item2, index2) => (
                        <li key={index2} 
                        className={
                          item2.isShow
                            ? 'col-4 d-flex align-items-center list-services'
                            : 'col-4 d-flex align-items-center list-services service-disabled'
                        }
                        >
                          <img
                            className="pr-3"
                            src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item2.imageUrl}`}
                            alt={item2.name}
                          />
                          <span>{item2.name}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))
              : ''}
          </div>
        </div>
      </div>
      {loader}
    </>
  );
}

export default FacilitiesComponent;
